import { createFeatureSelector } from '@ngrx/store';

import { IAppControlState } from './interfaces/layout-interface';

export const getAppControlState = createFeatureSelector<IAppControlState>('shared');
